"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectPlayer = void 0;
const vue_1 = require("vue");
const Button_1 = require("./common/Button");
const SelectPlayerRow_1 = require("./SelectPlayerRow");
const TranslateMixin_1 = require("./TranslateMixin");
exports.SelectPlayer = vue_1.default.component('select-player', {
    props: {
        players: {
            type: Array,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            selectedPlayer: undefined,
        };
    },
    components: {
        'select-player-row': SelectPlayerRow_1.SelectPlayerRow,
        Button: Button_1.Button,
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        saveData: function () {
            const result = [];
            result.push([]);
            if (this.selectedPlayer !== undefined) {
                result[0].push(this.selectedPlayer);
            }
            this.onsave(result);
        },
    },
    template: `<div>
  <div v-if="showtitle === true">{{ $t(playerinput.title) }}</div>
  <label v-for="player in (playerinput.players || [])" :key="player" class="form-radio form-inline">
    <input type="radio" v-model="selectedPlayer" :value="player" />
    <i class="form-icon"></i>
    <select-player-row :player="players.find((otherPlayer) => otherPlayer.color === player)"></select-player-row>
  </label>
  <Button v-if="showsave === true" size="big" :onClick="saveData" :title="$t(playerinput.buttonLabel)" />
</div>`,
});
//# sourceMappingURL=SelectPlayer.js.map